import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-catch-up-contribution',
  templateUrl: './catch-up-contribution.component.html',
  styleUrls: ['./catch-up-contribution.component.scss']
})
export class CatchUpContributionComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CatchUpContributionComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
